<mat-card class="activity-form-card">
    <mat-card-content>
        <form #programForm [formGroup]="newSchoolActivityForm" class="activity-form">
            <div class="modal-header activity-form__header">
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="modal-title">{{ 'ADD_ACTIVITY' | translate }}</h5>
                    </div>
                </div>
            </div>
            <div class="activity-form__content">
                <div class="d-grid mb-2 form-field">
                    <span>{{ 'ACADEMIC_YEAR' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <app-select-academic-year-only (academicYearChanged)="onChangeAcademicYear($event, 'add')"
                        class="w-100">
                    </app-select-academic-year-only>
                </div>
                <div class="d-grid mb-2 form-field">
                    <span>{{ 'SCHOOL_LOCATION' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <app-select-school-level-relation-v2
                        [academic_year]="this.newSchoolActivityForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event, 'add')"
                        [isDisabled]="!this.newSchoolActivityForm.get('academic_year')?.value" class="w-100">
                    </app-select-school-level-relation-v2>
                </div>
                <!-- <div class="d-grid col-md-5 mb-2">
                    <app-select-year-level-relation-v2
                            (yearLevelRelationChanged)="onChangeYearLevel($event,'add')"
                            [school_location_id]="this.newSchoolActivityForm.get('school_location_id')?.value"
                            [school_level_id]="this.newSchoolActivityForm.get('school_level_id')?.value"
                            [multiple]="true"
                            [isDisabled]="!this.newSchoolActivityForm.get('school_location_id')?.value">

                    </app-select-year-level-relation-v2>
                </div> -->
                <div class="d-grid form-field form-field--wide">
                    <span>{{ 'YEAR_LEVEL' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <div class="d-grid mb-2 form-field form-field--hint"
                        *ngIf="!this.newSchoolActivityForm.controls['school_location_id']?.value || !this.newSchoolActivityForm.controls['academic_year']?.value">
                        <i>{{ 'PLEASE_SELECT_ACADEMIC_YEAR_AND_SCHOOL_LEVEL' | translate }}</i>
                    </div>
                    <div class="row mb-2 year-level-options" *ngIf="this.newSchoolActivityForm.controls['school_location_id']?.value">
                        <div *ngFor="let year of yearLevelRelations" class="col-md-3">
                            <mat-checkbox mat-checkbox (change)="onChangeYearLevelByCheckbox($event, year)">
                                {{ year.description }}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="d-grid mb-2 form-field">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">
                        {{ 'SCHOOL_PROGRAM' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <app-select-school-program
                        [selectedProgramId]="this.newSchoolActivityForm.get('school_program_id')?.value"
                        [academic_year]="this.newSchoolActivityForm.get('academic_year')?.value"
                        [school_location_id]="this.newSchoolActivityForm.get('school_location_id')?.value"
                        [isDisabled]="this.yearLevelRelationsSelected.length <= 0 || disableSpSelect" class="w-100"
                        (schoolProgramChanged)="onChangeSchoolProgram($event, 'add')" [usingLocalStorage]="false">
                    </app-select-school-program>
                </div>
                <div class="d-grid mb-2 form-field">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">
                        {{ 'SCHOOL_PROGRAM_CATEGORY' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <app-select-school-program-category
                        [school_program_id]="this.newSchoolActivityForm.get('school_program_id')?.value"
                        [isDisabled]="!this.newSchoolActivityForm.get('school_program_id')?.value" [all]="true"
                        class="w-100" (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event, 'add')"
                        [usingLocalStorage]="false">
                    </app-select-school-program-category>
                </div>

                <div class="d-grid mb-2 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_NAME' | translate
                        }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                    <input class="form-control" type="text" placeholder="{{ 'ACTIVITY_NAME_PLACEHOLDER' | translate }}"
                        formControlName="activity_name" />
                </div>
                <div class="d-grid mb-4 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_DESCRIPTION' | translate
                        }}</span>
                    <textarea class="form-control" rows="3"
                        placeholder="{{ 'ACTIVITY_DESCRIPTION_PLACEHOLDER' | translate }}"
                        formControlName="activity_description"></textarea>
                </div>

                <div class="d-grid mb-2 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_NAME_ON_REPORT_CARD' |
                        translate }}</span>
                    <input class="form-control" type="text"
                        placeholder="{{ 'ACTIVITY_NAME_ON_REPORT_CARD_PLACEHOLDER' | translate }}"
                        formControlName="name_on_report_card" />
                </div>

                <div class="d-grid mb-2 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">Gender</span>
                    <div class="d-flex" style="gap: 16px;">
                        <mat-checkbox [checked]="newSchoolActivityForm.get('gender')?.value === 'all'" (change)="setGender('all')">All</mat-checkbox>
                        <mat-checkbox [checked]="newSchoolActivityForm.get('gender')?.value === 'M'" (change)="setGender('M')">Male</mat-checkbox>
                        <mat-checkbox [checked]="newSchoolActivityForm.get('gender')?.value === 'F'" (change)="setGender('F')">Female</mat-checkbox>
                    </div>
                </div>

                <div
                    class="d-grid mb-2 d-flex p-0 justify-content-space-evenly form-field form-field--wide date-fields">
                    <div class="col-md-4 col-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'START_DATE' | translate
                            }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" class="form-control" placeholder="Start date" formControlName="start_date"
                            (change)="changeActivityDate()">
                        <span *ngIf="activityDateInvalid" style="font-size: 14px; color: rgb(190, 0, 0);">*{{
                            'START_DATE_ERROR' | translate }}</span>
                    </div>
                    <div class="col-md-4 col-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'END_DATE' | translate }}<span
                                style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" class="form-control" placeholder="End date" formControlName="end_date"
                            (change)="changeActivityDate()">
                        <span *ngIf="activityDateInvalid" style="font-size: 14px; color: rgb(190, 0, 0);">*{{
                            'START_DATE_ERROR' | translate }}</span>
                    </div>
                    <div class="col-md-4 col-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'MAX_REGISTRATION_DATE' |
                            translate }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" class="form-control" placeholder="Max Registration date"
                            formControlName="max_registration_date" (change)="changeActivityDate()">
                        <span *ngIf="activityMaxRegistrationDateInvalid"
                            style="font-size: 14px; color: rgb(190, 0, 0);">*{{ 'MAX_REGISTRATION_DATE_ERROR' |
                            translate }}</span>
                    </div>
                </div>

                <!-- <div class="d-flex mb-2 align-items-center">
                    <label class="switch">
                        <input type="checkbox" (change)="onChangeActivityRuleBox()">
                        <span class="slider round"></span>
                    </label>
                    <div class="fs-6 ms-3">
                        {{ usingActivityRule ? 'Limit Per Year Level' : 'For All Year Level' }}
                    </div>
                </div> -->

                <div class="d-grid mb-2 form-field form-field--wide participant-fields">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">
                        {{ 'MIN_MAX_PARTICIPANT' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <div class="d-flex">
                        <div class="col-md-3 col-12 p-0 me-4">
                            <input class="form-control" type="number"
                                placeholder="{{ 'MIN_PARTICIPANT_PLACEHOLDER' | translate }}"
                                formControlName="min_participant" />
                        </div>
                        <div class="col-md-3 col-12 p-0 ms-4">
                            <input class="form-control" type="number"
                                placeholder="{{ 'MAX_PARTICIPANT_PLACEHOLDER' | translate }}"
                                formControlName="max_participant" />
                        </div>
                    </div>
                </div>

                <!-- <div class="d-grid mb-2" *ngIf="usingActivityRule">
                    <span class="mb-2" style="font-size: 14px; font-weight: bold; color: #333;">{{ 'MIN_MAX_PARTICIPANT' | translate }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                    <div formArrayName="rule_per_year_level" class="mb-2" *ngIf="this.newSchoolActivityForm.controls['school_location_id']?.value">
                        <div *ngFor="let year of ruleParticipantPerYearLevel.controls; let i = index" class="d-flex align-items-center mb-1" style="gap: 14px;" [formGroupName]="i">
                            <span class="col-md-1 text-end">{{ year.get('description')?.value || '-' }}</span>
                            <input class="form-control col-md-3" type="number" placeholder="{{ 'MIN_PARTICIPANT_PLACEHOLDER' | translate }}" formControlName="min_participant"/>
                            <input class="form-control col-md-3" type="number" placeholder="{{ 'MAX_PARTICIPANT_PLACEHOLDER' | translate }}" formControlName="max_participant"/>
                        </div>
                    </div>
                </div> -->

                <div class="d-grid mb-2 form-section form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_SCHEDULE' | translate
                        }}</span>

                    <div class="d-flex justify-content-between mb-2 row schedule-grid"
                        formArrayName="activity_schedule">
                        <div *ngFor="let schedule of activitySchedule.controls; let i = index" class="col fixed-col"
                            [formGroupName]="i">
                            <div>
                                <mat-checkbox (change)="onChangeSchoolDayByCheckbox($event, i)">
                                    {{ schedule.value.day }}
                                </mat-checkbox>

                                <div *ngIf="schedule.value.check" class="ps-3 py-1 block-day">
                                    <div><strong>{{ 'DAY' | translate }}:</strong> {{ schedule.value.day }}</div>
                                    <div class="align-items-center">
                                        <div class="inputschedule">
                                            <div class="mb-2">{{ 'START_TIME' | translate }}<input class="mb-2"
                                                    class="input-schedule" type="time" formControlName="time_start">
                                            </div>
                                            <div class="mb-2">{{ 'END_TIME' | translate }}<input class="mb-2"
                                                    class="input-schedule" type="time" formControlName="time_end"></div>
                                            <div class="mb-2">{{ 'VENUE' | translate }}<input class="mb-2"
                                                    class="input-schedule" type="text" formControlName="venue"></div>
                                            <div class="mb-2">{{ 'EQUIPMENT' | translate }}<input class="mb-2"
                                                    class="input-schedule" type="text" formControlName="equipment">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-grid mb-2 form-field">
                    <span style="font-size: 14px; font-weight: bold; color: #333;" *ngIf="!sessionIsOverriden">{{
                        'SESSIONS' | translate }}</span>
                    <span style="font-size: 14px; font-weight: bold; color: #333;" *ngIf="sessionIsOverriden">{{
                        'SESSION_OVERRIDEN' | translate }}</span>
                    <input class="form-control" type="number" formControlName="sessions" readonly
                        *ngIf="!sessionIsOverriden">
                    <input class="form-control" type="number" formControlName="session_override"
                        *ngIf="sessionIsOverriden">
                </div>

                <div class="d-grid mb-2 form-field">
                    <span></span>
                    <div class="d-flex align-items-center">
                        <label class="switch">
                            <input type="checkbox" (change)="onToogleSessionOverride()">
                            <span class="slider round"></span>
                        </label>
                        <div class="fs-6 ms-3">
                            {{ 'OVERRIDE_SESSION' | translate }}
                        </div>
                    </div>
                </div>

                <div class="d-grid mb-2 form-field">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'PARTICIPATION_FEE' | translate
                        }}</span>
                    <input type="text" class="form-control" rows="3" (change)="onChangeFeesParticipationFee()"
                        formControlName="participation_fee" mask="separator.0" thousandSeparator=".">
                </div>

                <div class="d-grid mb-2 form-section form-field--wide score-section">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_SCORE' | translate
                        }}</span>

                    <div class="d-flex mb-2">
                        <!-- <mat-checkbox (change)="onChangeScorePredicate()">
                        {{ usingScoreRange ?( 'PREDICATE_AND_SCORE' | translate) : ('PREDICATE_ONLY' | translate) }}
                    </mat-checkbox> -->
                        <label class="switch">
                            <input type="checkbox" (change)="onChangeScorePredicate()">
                            <span class="slider round"></span>
                        </label>
                        <div class="fs-6 ms-3">
                            {{ usingScoreRange ?( 'PREDICATE_AND_SCORE' | translate) : ('PREDICATE_ONLY' | translate) }}
                        </div>
                    </div>

                    <div class="d-flex mb-2 align-items-center">
                        <label class="switch">
                            <input type="checkbox" (change)="onToggleAllScorePeriod()" [checked]="allScorePeriod">
                            <span class="slider round"></span>
                        </label>
                        <div class="fs-6 ms-3">
                            {{ 'ALL_PERIOD' | translate }}
                        </div>
                    </div>

                    <ng-template #scoreTable let-periodId="periodId">
                        <div class="table-responsive">
                            <table class="table table-bordered form-table">
                                <thead>
                                    <tr>
                                        <th rowspan="2">{{ 'SCORE_NAME' | translate }}</th>
                                        <th [attr.colspan]="usingScoreRange ? 5 : 3">{{ 'SCORE_DETAIL' | translate }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <ng-container *ngIf="usingScoreRange">
                                            <th>{{ 'MIN_SCORE' | translate }}<span class="text-danger">*</span></th>
                                            <th>{{ 'MAX_SCORE' | translate }}<span class="text-danger">*</span></th>
                                        </ng-container>
                                        <th>{{ 'PREDICATE' | translate }}</th>
                                        <th>{{ 'DESCRIPTION' | translate }}</th>
                                        <th *ngIf="isScoreRangeMultiple" class="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let score of getScoreRange(periodId).controls; let i = index">
                                        <tr>
                                            <td [attr.rowspan]="getRowspan(i, periodId)">
                                                <input type="text" class="form-control"
                                                    [formControl]="convertToFormControl(score.get('score_name'))">
                                            </td>

                                            <ng-container *ngIf="getScoreRangeDetailByPeriod(i, periodId).length === 0">
                                                <td [attr.colspan]="usingScoreRange ? 5 : 3">{{ 'NO_DETAILS' | translate
                                                    }}</td>
                                            </ng-container>
                                        </tr>

                                        <ng-container *ngIf="getScoreRangeDetailByPeriod(i, periodId).length > 0">
                                            <tr
                                                *ngFor="let detail of getScoreRangeDetailByPeriod(i, periodId).controls; let j = index">
                                                <td *ngIf="usingScoreRange">
                                                    <input type="number" class="form-control"
                                                        [formControl]="convertToFormControl(detail.get('minimum_score'))">
                                                </td>
                                                <td *ngIf="usingScoreRange">
                                                    <input type="number" class="form-control"
                                                        [formControl]="convertToFormControl(detail.get('maximum_score'))">
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control"
                                                        [formControl]="convertToFormControl(detail.get('predicate'))">
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control"
                                                        [formControl]="convertToFormControl(detail.get('description'))">
                                                </td>
                                                <td *ngIf="getScoreRangeDetailByPeriod(i, periodId).length > 1" class="text-end">
                                                    <button type="button" class="action-btn action-btn-delete"
                                                        (click)="removeScoreDetail(i, j, periodId)"
                                                        [attr.aria-label]="'REMOVE' | translate"
                                                        [title]="'REMOVE' | translate">
                                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td [attr.colspan]="usingScoreRange ? 6 : 4" class="text-end">
                                                    <button type="button" class="action-btn action-btn-edit"
                                                        (click)="addScoreDetail(i, periodId)"
                                                        [attr.aria-label]="'ADD_DETAIL' | translate"
                                                        [title]="'ADD_DETAIL' | translate">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <button type="button" class="action-btn action-btn-delete" (click)="removeScore(periodId)"
                                *ngIf="getScoreRange(periodId).length > 1">- {{ 'REMOVE_SCORE' | translate }}</button>
                            <button type="button" class="action-btn action-btn-create" (click)="addScore(periodId)">+ {{
                                'ADD_SCORE'
                                | translate }}</button>
                        </div>
                    </ng-template>

                    @if (allScorePeriod) {
                    <ng-container *ngTemplateOutlet="scoreTable; context: { periodId: null }"></ng-container>
                    } @else {
                    <mat-tab-group *ngIf="periodList.length > 0">
                        @for (period of periodList; track period.period_id) {
                        <mat-tab [label]="period.name">
                            <div class="mt-4">
                                <ng-container
                                    *ngTemplateOutlet="scoreTable; context: { periodId: period.period_id }"></ng-container>
                            </div>
                        </mat-tab>
                        }
                    </mat-tab-group>
                    }
                </div>

                <div class="d-grid mb-2 form-section form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_FEE' | translate
                        }}</span>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered form-table">
                            <thead>
                                <tr>
                                    <th>{{ 'COACH_ASSISTANT_FEE' | translate }}</th>
                                    <th>{{ 'EQUIPMENT_FEE' | translate }}</th>
                                    <th>{{ 'VENUE_FEE' | translate }}</th>
                                    <th>{{ 'OTHER_FEE' | translate }}</th>
                                    <th>{{ 'TOTAL_FEE' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <input type="text" class="form-control" (change)="onChangeFees()"
                                            formControlName="coach_fee" mask="separator.0" thousandSeparator=".">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" (change)="onChangeFees()"
                                            formControlName="equipment_fee" mask="separator.0" thousandSeparator=".">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" (change)="onChangeFees()"
                                            formControlName="venue_fee" mask="separator.0" thousandSeparator=".">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" (change)="onChangeFees()"
                                            formControlName="other_fee" mask="separator.0" thousandSeparator=".">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" [(ngModel)]="totalFee"
                                            [ngModelOptions]="{standalone: true}" readonly mask="separator.0"
                                            thousandSeparator=".">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="person-role-row form-field--wide">
                    <div class="d-flex mb-2 align-items-center toggle-row">
                        <!-- <mat-checkbox (change)="switchSupervisor()">
                      {{ 'SUPERVISOR' | translate }}
                    </mat-checkbox> -->
                        <label class="switch">
                            <input type="checkbox" (change)="switchSupervisor()">
                            <span class="slider round"></span>
                        </label>
                        <div class="fs-6 ms-3">
                            {{ 'SUPERVISOR' | translate }}
                        </div>
                    </div>

                    <div class="person-role-selector" *ngIf="supervisor">
                        <div class="person-role-selector__label">
                            <span>{{ 'SUPERVISOR' | translate }}</span>
                            <small>Assign one or more supervisors</small>
                        </div>
                        <div [formGroup]="newSchoolActivityForm">
                            <ng-select [items]="supervisorList"
                                bindLabel="staff_name" bindValue="staff_id" [selectableGroup]="false" [multiple]="true"
                                [closeOnSelect]="false" [clearable]="true" [searchable]="true"
                                placeholder="Search and select supervisors" formControlName="supervisor"
                                class="selector-style person-role-selector__control">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="custom-option-style">
                                        {{ item.staff_name }}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="person-role-row form-field--wide">
                    <div class="d-flex mb-2 align-items-center toggle-row">
                        <!-- <mat-checkbox (change)="switchCoach()">
                      {{ 'COACH' | translate }}
                  </mat-checkbox> -->
                        <label class="switch">
                            <input type="checkbox" (change)="switchCoach()">
                            <span class="slider round"></span>
                        </label>
                        <div class="fs-6 ms-3">
                            {{ 'COACH' | translate }}
                        </div>
                    </div>

                    <div class="person-role-selector" *ngIf="coach">
                        <div class="person-role-selector__label">
                            <span>{{ 'COACH' | translate }}</span>
                            <small>Assign one or more coaches</small>
                        </div>
                        <div [formGroup]="newSchoolActivityForm">
                            <ng-select [items]="coachList" bindLabel="fullname"
                                bindValue="user_id" [selectableGroup]="false" [multiple]="true" [closeOnSelect]="false"
                                [clearable]="true" [searchable]="true" placeholder="Search and select coaches"
                                formControlName="coach" class="selector-style person-role-selector__control">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="custom-option-style">
                                        {{ item.fullname }}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="status-selector mb-2 form-field--wide">
                    <div class="status-selector__label">
                        <span>{{ 'STATUS' | translate }} <b aria-hidden="true">*</b></span>
                        <small>Choose the activity availability</small>
                    </div>
                    <div [formGroup]="newSchoolActivityForm">
                        <ng-select [items]="statusList" [selectableGroup]="false" formControlName="status"
                            [clearable]="false" [searchable]="false" class="selector-style status-selector__control">
                            <ng-template ng-label-tmp let-item="item">
                                <span class="status-dot" [ngClass]="'status-dot--' + (item | lowercase)"></span>
                                {{ item }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style status-option">
                                    <span class="status-dot" [ngClass]="'status-dot--' + (item | lowercase)"></span>
                                    {{ item }}
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <div class="d-grid form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{
                        'REGISTER_STUDENT' | translate }}:
                    </span>
                    <mat-slide-toggle (toggleChange)="onToggleAllPeriod()" [checked]="allPeriod"
                        class="example-margin period-toggle" [color]="color">
                        {{ 'INSERT_ALL_PERIOD' | translate }}
                    </mat-slide-toggle>
                </div>
                @if (allPeriod) {
                <div class="mb-3 form-field--wide" *ngIf="periodList.length > 0">
                    <app-table-participant [schoolProgramActivityId]="null"
                        [academicYear]="newSchoolActivityForm.get('academic_year')?.value"
                        [yearLevelId]="yearLevelRelationsSelected"
                        [schoolLocationId]="newSchoolActivityForm.get('school_location_id')?.value"
                        [canSelect]="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']"
                        [gender]="newSchoolActivityForm.get('gender')?.value"
                        (checkedParticipantsChange)="onCheckedParticipantsChange($event)">
                    </app-table-participant>
                </div>
                } @else {
                <div class="mb-3 form-field--wide" *ngIf="periodList.length > 0">
                    <mat-tab-group (selectedTabChange)="changePeriodTab()">
                        @for (period of periodList; track period.period_id) {
                        <mat-tab [label]="period.name">
                            <div class="mt-4 mb-2">
                                <app-table-participant [schoolProgramActivityId]="null"
                                    [academicYear]="newSchoolActivityForm.get('academic_year')?.value"
                                    [yearLevelId]="yearLevelRelationsSelected"
                                    [schoolLocationId]="newSchoolActivityForm.get('school_location_id')?.value"
                                    [canSelect]="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']"
                                    [periodId]="period.period_id"
                                    [gender]="newSchoolActivityForm.get('gender')?.value"
                                    (checkedParticipantsChange)="onCheckedParticipantsChange($event, period)">
                                </app-table-participant>
                            </div>
                        </mat-tab>
                        }
                    </mat-tab-group>
                </div>
                }

                <!-- <div class="d-grid mb-2">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'APPROVER' | translate }}</span>
                  <div [formGroup]="newSchoolActivityForm">
                      <ng-select (change)="onChangeApprover($event)"
                                  [items]="approverList"
                                  bindLabel="fullname"
                                  bindValue="user_id"   
                                  [selectableGroup]="false"
                                  class="selector-style">
                                  <ng-template ng-option-tmp let-item="item">
                                      <div class="custom-option-style">
                                          {{ item.fullname }}
                                      </div>
                                  </ng-template>
                      </ng-select>
                  </div>
              </div> -->

                <!-- <i (click)="click()">TEST</i> -->

                <div class="form-actions form-field--wide">
                    <button type="button" class="gradient-button mt-3 me-1" (click)="onBack()">Cancel</button>
                    <button type="submit" class="gradient-button mt-3 me-1" [disabled]="disableButtonAdd"
                        *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']"
                        (click)="onSubmitAddActivity()">Save</button>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
